import {autoinject, bindable} from 'aurelia-framework';


@autoinject()
export class SneakCustomAttribute {
  @bindable({ primaryProperty: true }) tag: string;
  absolute: boolean = false;
  sneakClass: string = '';
  offset: number = 0;
  checkPosition: any;
  resize: any;
  windowHeight: number;

  constructor(private element: Element) {

    this.sneakClass = this.element.getAttribute('sneak-class');
    this.offset = Number(this.element.getAttribute('sneak-offset'));
    this.absolute = this.element.getAttribute('sneak-absolute') == 'true';

    this.checkPosition = () => {
      this._checkPosition()
    };

    this.resize = () => {
      this.windowHeight = window.innerHeight;
    };

    window.addEventListener('scroll', this.checkPosition);
    window.addEventListener('scroll', this.resize);
    this.resize();
    this.checkPosition()
  }

  _checkPosition() {
    if(this.absolute){
      if(window.scrollY > this.offset) {
        this.element.classList.add(this.sneakClass);
      } else {
        this.element.classList.remove(this.sneakClass);
      }

    }else {
      const positionFromTop = this.element.getBoundingClientRect().top;
      if((positionFromTop + this.offset) - this.windowHeight <= 0) {
        this.element.classList.add(this.sneakClass);
      }else {
        this.element.classList.remove(this.sneakClass);
      }
    }
  }


  valueChanged(newValue, oldValue) {
    //
  }
}
